var moment = require('moment');

function unlockButton(btnEl) {
  if (btnEl != undefined && btnEl.length != 0) {
    btnEl.prop('disabled', false);
  } else {
    return false
  }
};

function lockButton(btnEl) {
  if (btnEl != undefined && btnEl.length != 0) {
    btnEl.prop('disabled', true);
  } else {
    return false
  }
};

function isSelected(selectField) {
  if (selectField != undefined) {
    if (selectField.find('option:selected').val() != '') {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
};

function isRadioChecked(radioName) {
  var inputName = 'input[type=radio][name="market_value[' + radioName + ']"]:checked';

  if ($(inputName).length > 0) {
    return true
  } else {
    return false
  }
};

function isValidDate(dateString, minDate) {
  if (dateString != undefined && dateString != '') {
    var date = moment(dateString, "DD/MM/YYYY"),
        firstDate = minDate === false ? moment('01/01/2000', 'DD/MM/YYYY') : moment('01/01/1900', 'DD/MM/YYYY'),
        now = moment();

    return (date.isValid() && date.isSameOrBefore(now) && date.isSameOrAfter(firstDate))
  } else {
    return false
  }
};

$(document).ready(function () {
  $('.progress-bar').tooltip('show');
  $('[data-toggle="popover"]').popover({
    trigger: 'focus',
    html: true
  });

  var $personalBtn = $('#personal_button'),
      $precBtn = $('#prec_button'),
      $dateBtn = $('#dates_button'),
      $reviewButton = $('#to_review'),
      $docInput = $('#market_value_people_attributes_0_document'),
      $nameInput = $('#market_value_people_attributes_0_name'),
      $precNumInput = $('#market_value_precatory_number'),
      $faceValInput = $('#market_value_face_value'),
      $lastCalcInput = $('#market_value_last_calculation'),
      $expeditionDateInput = $('#market_value_expedition_date'),
      $courtInput = $('#market_value_court_id'),
      $enteInput = $('#market_value_debtor_id'),
      $procTypeInput = $('#market_value_process_type_id'),
      $attorneyInput = $('#market_value_attorney_fee'),
      $rraMonthInput = $('#market_value_rra_months') ;

  function validateFirstStep() {
    if ($nameInput.val() != '' && $nameInput.val().length >= 3 && $docInput.val() != '' && $docInput.next().find('li').text().length == 0 && isRadioChecked('original_creditor')) {
      unlockButton($personalBtn);
    } else {
      lockButton($personalBtn);
    }
  };

  function validateSecondStep() {
    if ($precNumInput.val() != '' && $precNumInput.val().length >= 4 && isSelected($courtInput) && isSelected($enteInput)) {
      if ($("#market_value_court_id option:selected").text().match(/trf/i) != null && $("#market_value_court_id option:selected").text().match(/trf/i).length > 0) {

        if (isSelected($procTypeInput)) {
          unlockButton($precBtn);
        } else {
          lockButton($precBtn);
        }

      } else {
        unlockButton($precBtn);
      }
    } else {
      lockButton($precBtn);
    }
  };

  function validateThirdStep() {
    if ($faceValInput.val() != '' &&
        $lastCalcInput.val() != '' &&
        $lastCalcInput.val().length == 10 &&
        $lastCalcInput.next().find('li').text().length == 0 &&
        $expeditionDateInput.val() != '' &&
        $expeditionDateInput.val().length == 10 &&
        $expeditionDateInput.next().find('li').text().length == 0
      ) {
      unlockButton($dateBtn)
    } else {
      lockButton($dateBtn)
    }
  };

  function validateFourthStep() {
    if (isRadioChecked('social_security_discount') && $attorneyInput.val() != '' && isRadioChecked('rra_ir')) {

      if ($('input[type=radio][name="market_value[rra_ir]"]:checked').val() == 'false') {
        if ($('input[type=radio][name="market_value[rra]"]:checked').val() == 'true') {
          if ($rraMonthInput.val() != '') {
            unlockButton($reviewButton);
          } else {
            lockButton($reviewButton);
          }
        } else {
          if ($('input[type=radio][name="market_value[rra]"]:checked').length != 0) {
            unlockButton($reviewButton);
          } else {
            lockButton($reviewButton);
          }
        }
      } else {
        unlockButton($reviewButton);
      }

    } else {
      lockButton($reviewButton);
    }
  };

  // First step validations
  $docInput.keydown(function(){
      try {
          $docInput.unmask();
      } catch (e) {}

      var tamanho = $docInput.val().length;

      if(tamanho < 11){
          $docInput.mask("999.999.999-99");
      } else {
          $docInput.mask("99.999.999/9999-99");
      }

      // ajustando foco
      var elem = this;
      setTimeout(function(){
          // mudo a posição do seletor
          elem.selectionStart = elem.selectionEnd = 10000;
      }, 0);
      // reaplico o valor para mudar o foco
      var currentValue = $(this).val();
      $(this).val('');
      $(this).val(currentValue);
  });

  $docInput.on('keyup focusout', function(e){
    var value = $docInput.val();

    if (value.length >= 14) {
      $.get(
        $docInput.data('validate-url'),
        { "document": value },
        function(data, status){
          if (data['error']) {
            $docInput.next().find('li').text(data['message']);
            lockButton($personalBtn);
          } else {
            validateFirstStep();
          }
        }
      )
    }
  });

  $docInput.on('focusin', function(){
    $docInput.next().find('li').text('');
  });

  $nameInput.on('keyup focusout', function(){
    validateFirstStep();
  });

  $('input[type=radio][name="market_value[original_creditor]"]').on('click', function(){
    validateFirstStep();
  });

  // Second part validations
  $("#market_value_debtor_id, #market_value_process_type_id, #market_value_court_id").on('change focusout', function(){
    validateSecondStep();
  })

  $("#market_value_precatory_number").on('keyup focusout', function(){
    validateSecondStep();
  });

  $courtInput.on('change focusout ready', function(){
    value = $("#market_value_court_id option:selected").text();

    if (value.match(/trf/i) != null && value.match(/trf/i).length > 0) {
      $('#process_type_div').removeClass('d-none');
    } else {
      $('#process_type_div').addClass('d-none');
    }
  });

  // Third step validations
  $faceValInput.mask('#.##0,00', {reverse: true});
  $lastCalcInput.mask('99/99/9999');
  $expeditionDateInput.mask('99/99/9999');

  $('#market_value_last_calculation, #market_value_expedition_date').on('focusout', function(){
    var $this = $(this);

    if (!isValidDate($this.val())) {
      $this.next().find('li').text('Data inválida');
    }
  });

  $('#market_value_last_calculation, #market_value_expedition_date').on('focusin', function(){
    $(this).next().find('li').text('');
  });

  $('#market_value_face_value, #market_value_last_calculation, #market_value_expedition_date').on('keyup focusout', function(){
    validateThirdStep()
  });


  // Fourth step validations
  $('input[type=radio][name="market_value[rra_ir]"]').click(function(){
    if ($(this).val() == "false") {
      $('div#is_not_isent').removeClass('d-none');
    } else {
      $('div#is_not_isent').addClass('d-none');
      $('div#is_rra').addClass('d-none');
      $rraMonthInput.val('');
      $('input[type=radio][name="market_value[rra]"]').prop('checked', false);
    }
  });

  $('input[type=radio][name="market_value[rra]"]').click(function() {
    if ($(this).val() == "false") {
      $('div#is_rra').addClass('d-none');
      $rraMonthInput.val('');
    } else {
      $('div#is_rra').removeClass('d-none');
    }
  });

  $('#market_value_rra_months, #market_value_attorney_fee').on('keyup focusout', function(){
    validateFourthStep();
  });

  $('input[type=radio][name="market_value[social_security_discount]"], input[type=radio][name="market_value[rra]"], input[type=radio][name="market_value[rra_ir]"]').on('click', function(){
    validateFourthStep();
  });

  $reviewButton.on('click', function(){
    $('#document_p').text($docInput.val());
    $('#name_p').text($nameInput.val());
    $('#original_creditor_p').text(
      $('input[type=radio][name="market_value[original_creditor]"]:checked').next().text()
    );
    $('#precatorio_p').text($precNumInput.val());
    $('#face_value_p').text($faceValInput.val());

    // Court
    var court = $("#market_value_court_id option:selected").text();
    var $processType = $('#process_type_h5, #process_type_p');

    $('#court_p').text(court);
    if (court.match(/trf/i) != null && court.match(/trf/i).length > 0) {
      $processType.removeClass('d-none');
      $('#process_type_p').text($('#market_value_process_type_id option:selected').text());
    } else {
      $processType.addClass('d-none');
      $('#process_type_p').text('');
    }

    // Debtor
    $('#debtor_p').text(
      $("#market_value_debtor_id option:selected").text()
    );

    // Social security
    $('#social_security_discount_p').text(
      $('input[type=radio][name="market_value[social_security_discount]"]:checked').next().text()
    );

    // Attorney Fee
    $('#attorney_fee_p').text($attorneyInput.val() + '%');

    // RRA
    $('#rra_ir_p').text($('input[type=radio][name="market_value[rra_ir]"]:checked').next().text());
    var $rraMonth = $('#rra_month_h5, #rra_month_p');
    var $rra = $('rra_p, #rra_h5');

    if ($("input[type=radio][name='market_value[rra_ir]']:checked").val() == 'false') {
      $rra.removeClass('d-none');
      $('#rra_p').text($("input[type=radio][name='market_value[rra]']:checked").next().text());

      if ($("input[type=radio][name='market_value[rra]']:checked").val() == 'true') {
        $rraMonth.removeClass('d-none');
        $('#rra_month_p').text($rraMonthInput.val());
      } else {
        $rraMonth.addClass('d-none');
      }
    } else {
      $rra.addClass('d-none');
      $rraMonth.addClass('d-none');

      $('#rra_month_p').text('');
      $('#rra_p').text('');
    }
  });

  $('#go_back').on('click', function(){
    $('.btn-market-value').removeClass('active');
  });

  $('button[data-toggle="tab"]').on('shown.bs.tab', function(e){
    navigationForms = ['personal_button', 'prec_button', 'dates_button', 'to_review']
    var currId = $(e.target).attr("id");
    markDot(navigationForms, currId)
    if(navigationForms.includes(currId)){
      $('#text-calc-market').addClass('d-none');
    }
    else {
      $('#text-calc-market').removeClass('d-none');
    }
  });
});

function markDot(navArray, currId) {
  for (var i = 0; i < navArray.length; i++) {
    if(navArray[i] == currId){
      $('#dot_' + navArray[i + 1]).addClass('active')
    }
    else {
      $('#dot_' + currId).removeClass('active')
    }
  }
}

